import QuickHealth from './QuickHealth';
export default QuickHealth;


// WEBPACK FOOTER //
// ./src/components/App/ClientListWithMap/ClientDetail/QuickHealth/index.js